
const getters = {
  tag: state => state.tags.tag,
  website: state => state.common.website,
  userInfo: state => state.user.userInfo,
  userDept: state => state.user.userDept,
  groupCompanyFlag: state => state.user.groupCompanyFlag,
  account: state => state.user.account,
  theme: state => state.common.theme,
  themeName: state => state.common.themeName,
  isCollapse: state => state.common.isCollapse,
  isLock: state => state.common.isLock,
  lockPasswd: state => state.common.lockPasswd,
  tagList: state => state.tags.tagList,
  tagCurrent: state => state.tags.tagCurrent,
  tagWel: state => state.tags.tagWel,
  token: state => state.common.token,
  roles: state => state.user.roles,
  permission: state => state.user.permission,
  menu: state => state.user.menu,
  errLog: state => state.errLog.errLog,
  defaultCompany: state => state.user.defaultCompany,
  appId: state => state.common.appId,
  formPreDate:state => state.form.preDate,//出国日期
  formEntryDate:state => state.form.entryDate,//回国日期
  formCountryNameList:state => state.form.countryNameList,//回国日期
  formCountryList:state => state.form.optionCountryList,//可选国家列表
  isFullscreen:state => state.form.isFullscreen,
  getWorkLetterId:state => state.form.getWorkLetterId,
  companyId: state => {
    if (state.user.defaultCompany) {
      return state.user.defaultCompany.companyId
    } else {
      return ''
    }
  },
  binCode: state => {
    if (state.user.defaultCompany) {
      return state.user.defaultCompany.binCode
    } else {
      return ''

    }
  },
  versionNumber: state => state.common.versionNumber,
}
export default getters
